import { render, staticRenderFns } from "./UnitSale.vue?vue&type=template&id=29cd64be&"
import script from "./UnitSale.vue?vue&type=script&lang=js&"
export * from "./UnitSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports